import { Endpoints } from 'types/endpoints';

import Page from 'models/Page';

import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface CreateParams {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    content: string;
}
export const create = async (params: CreateParams): Promise<Page> => {
    const response = await request({
        method: 'POST',
        path: withVariables(Endpoints.PublicContactForm, params),
        requestParams: params,
    });

    return response;
};
